<template>
  <div class="result">
    <div class="result__data">
      <form class="form">
        <div class="form__fieldset">
          
          <div class="form__container form__container--short">
            <label for="market_id" class="form__label">Mercado</label>
            <div class="form__select-container">
              <select name="market_id" id="market_id" v-model="entry.market_id" class="form__select" v-if="markets">
                <option :value="null">Seleccione el mercado</option>
                <option v-for="(market, index) in markets" :key="index" :value="market.id">{{market.name_es}}</option>
              </select>
            </div>
          </div>

          <div class="form__container form__container--short">
            <label for="sector_id" class="form__label">Sector</label>
            <div class="form__select-container">
              <select name="sector_id" id="sector_id" v-model="entry.sector_id" class="form__select" v-if="sectors">
                <option :value="null">Seleccione el sector</option>
                <option v-for="(sector, index) in sectors" :key="index" :value="sector.id">{{sector.name_es}}</option>
              </select>
            </div>
          </div>

          <div class="form__container form__container--short">
            <label for="industry" class="form__label">Industria</label>
            <input type="text" name="industry" id="industry" v-model="entry.industry" class="form__input" />
          </div>

          <div class="form__container form__container--short">
            <label for="position_id" class="form__label">Posición</label>
            <div class="form__select-container">
              <select name="position_id" id="position_id" v-model="entry.position_id" class="form__select">
                <option :value="null">Seleccione la posición</option>
                <option value="1">Long</option>
                <option value="2">Short</option>
              </select>
            </div>
          </div>

          <div class="form__container form__container--short">
            <label for="portfolio" class="form__label">Portafolio</label>
            <input type="text" name="portfolio" id="portfolio" v-model="entry.portfolio" class="form__input" />
          </div>

        </div>
      </form>
    </div>
    <div class="result__options">
      <button class="btn btn__default btn--small" @click.prevent="saveEntry" >Guardar</button>
      <button class="btn btn__caution btn--small" @click="deleteEntry">Borrar</button>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>


<script>
import confirmation from "@/components/layout/confirmation";
import httpService from "@/api/request";
export default {
  props: {
    entry: {
      type: Object,
      required: false,
      default() {
        return {
          id: null,
          market_id: null,
          sector_id: null,
          position_id: null,
          industry: null,
          portfolio: 0
        };
      }
    },
    markets: {
      type: Array,
      required: true
    },
    sectors: {
      type: Array,
      requred: true
    }
  },
  mixins: [httpService],
  components: {
    confirmation
  },
  data: function() {
    return {
      confirm: false
    };
  },
  mounted: function() {
    this.$on("continue", () => {
      this.confirm = false;
      this.proccedToDelete();
    });
  },
  methods: {
    deleteEntry: function() {
      if (this.entry.id) {
        this.confirm = true;
      } else {
        this.$emit("deleted");
      }
    },
    proccedToDelete: function() {
      let httpRequest = {
        module: "portfolio"
      };
      this.delete(this.entry.id, httpRequest).then(() => {
        this.$store.commit("notificate", {
          title: "ENTRADA BORRADA",
          text: "La entrada ha sido borrada correctamente.",
          type: "success"
        });
        this.$emit("update");
      });
    },
    saveEntry: function() {
      let httpRequest = {
        params: "",
        element: this.entry,
        module: "portfolio"
      };
      let action = null;
      if (this.entry.id) {
        action = this.put(this.entry.id, httpRequest);
      } else {
        action = this.post(httpRequest);
      }
      action
        .then(response => {
          this.$emit("update");
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/portfolio/entry.vue